import styled, { css } from 'styled-components';
import { Typography, TextField } from '@mui/material';

import colors from '../../../styles/colors';
import DialogModal from '../../DialogModal';
import Button from '../../Button';

const RoundedModal = styled(DialogModal)`
  .MuiDialogContent-root, .MuiPaper-root {
    border-radius: 8px;
  }
`;

const ModalContentWrapper = styled.div`
  outline: 0;
  height: fit-content;
  min-width: 400px;
  background-color: ${colors.shades.secondary5};
  border-radius: 8px;
  border: 1px solid ${colors.shades.secondary7};
  position: relative;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  column-gap: 16px;
  margin-bottom: 10px;
  padding: 10px 50px 10px 50px;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 50px 24px 50px;
  color: ${colors.shades.secondary3};
`;

const Title = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 46px;
`;

const Description = styled(Typography)`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.shades.gamma2};
  margin-top: 5px;
`;

const buttonStyles = css`
  height: 38px;
  font-size: 14px;
  border-radius: 5px;
  width: 100px;
`;

const CancelButton = styled(Button)`
  ${buttonStyles};
  background: ${colors.shades.gamma10};
  border: 1px solid ${colors.shades.gamma5};
  color: ${colors.base.alpha};
  &:hover {
    background: ${colors.shades.gamma10};
  }
`;

const ActionButton = styled(Button)`
  ${buttonStyles};
  background: ${colors.base.primary};
  border: 1px solid ${colors.shades.primary1};
  color: ${colors.base.beta};
  &:hover {
    background: ${colors.base.primary};
  }
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 20px;
  width: 100%;
`;

const NoteInputContainer = styled.div`
  padding: 0 50px 20px 50px;
`;

export {
  Title,
  Description,
  ActionsContainer,
  RoundedModal,
  ModalContentWrapper,
  HeaderContainer,
  ActionButton,
  CancelButton,
  StyledTextField,
  NoteInputContainer,
};
